import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const DAYS14 = 14 * 864e5;
const KEY = "cx_new_seen";
let cache = null;

const seenMap = () => { try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; } };

export const useNewBadges = () => {
  const { pathname } = useLocation();
  const [rel, setRel] = useState(cache);
  const [seen, setSeen] = useState(seenMap);
  useEffect(() => {
    if (cache) return;
    api.get("/releases").then((r) => {
      const top = (r.data || [])[0];
      cache = top && top.nav?.length && Date.now() - new Date(top.published_at || top.created_at).getTime() < DAYS14 ? { v: top.version, nav: top.nav } : { v: null, nav: [] };
      setRel(cache);
    }).catch(() => {});
  }, []);
  useEffect(() => {
    const on = () => setSeen(seenMap());
    window.addEventListener("cx-new-seen", on);
    return () => window.removeEventListener("cx-new-seen", on);
  }, []);
  useEffect(() => {
    if (!rel?.v) return;
    const hit = rel.nav.find((p) => pathname.startsWith(p));
    const cur = seenMap();
    if (hit && !(cur[rel.v] || []).includes(hit)) {
      localStorage.setItem(KEY, JSON.stringify({ [rel.v]: [...(cur[rel.v] || []), hit] }));
      window.dispatchEvent(new Event("cx-new-seen"));
    }
  }, [pathname, rel]);
  return (paths) => Boolean(rel?.v) && rel.nav.some((p) => paths.some((x) => p.startsWith(x)) && !(seen[rel.v] || []).includes(p));
};

export const NewBadge = ({ t, className = "", testid }) => (
  <span className={`cx-new-badge shrink-0 rounded-full px-1.5 py-px text-[9px] font-bold uppercase tracking-wider text-white ${className}`} data-testid={testid}>{t("nav.new")}</span>
);
